import { render, staticRenderFns } from "./DocType.vue?vue&type=template&id=2787a4c1&"
import script from "./DocType.vue?vue&type=script&lang=js&"
export * from "./DocType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DocType.vue"
export default component.exports